// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"TransparentButton_buttonWrapper__tRxzu","buttonText":"TransparentButton_buttonText__gboZc"};